<div class="my-3 my-md-5">
    <div class="container-fluid">
    	<div class="col-sm-6 float-left">
	        <h1 class="page-title">Hospitals List</h1>
	    </div>
	    <div class="col-sm-6 float-left add_user_btn" *ngIf="myrole=='1' || myrole=='3' || myrole=='4' || myrole=='9' || myrole=='8' || myrole=='10' || myrole=='6'">
            <a *ngIf="myrole=='1' && userId=='89'" class="btn btn-success mr-3" (click)="showModal()"><i class="fa fa-file-excel"></i> Update Hospital Data</a>
	        <a routerLink="/create-hospital" class="btn btn-success">
		        <i class="fa fa-plus" aria-hidden="true"></i> Add New Hospital
		    </a>
	    </div>
         <!-- Update Hospital Ranking -->
         <div class="col-sm-3 p-3" *ngIf="myrole=='1'">
            <a class="btn btn-success text-white" (click)="showRankingStatusUpdateModal()"><i class="fa fa-file-excel"></i> Update Hospital Ranking</a><br>
            <a href="{{sc3Url}}crm/hospital/hospital-rating-update-sample-import.csv" target="_blank">Sample CSV</a>
        </div>

    </div>
    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                    <div class="row mb-4 mt-4">
                        <div class="col-sm-3"><input class="form-control" [(ngModel)]="search" type="text" placeholder="Search" /></div>

                        <div class="col-sm-3">
                            <!-- <mat-select  placeholder="Circle" (selectionChange)="loadHospitalsList(0,perpage)" [(ngModel)]="circle" (click)="setSearchValue()"> -->
                                
                                <mat-select  placeholder="Circle" [(ngModel)]="circle" (click)="setSearchValue()"><input class="mySearchInput"
                                #circleSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'circle')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="circleSearch">
                                <mat-option >All</mat-option>
                                <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-3">
                            <!-- <mat-select  placeholder="Status" (selectionChange)="loadHospitalsList(0,perpage)" [(ngModel)]="status"> -->
                                <mat-select  placeholder="Status" [(ngModel)]="status">
                                <mat-option >All</mat-option>
                                <mat-option value="1">Active</mat-option>
                                <mat-option value="0">In-Active</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-3">
                            <button type="button" class="btn btn-primary mb-4" (click)="loadHospitalsList(0,perpage)"> <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                            <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i class="fa fa-sync"></i> Reset Filters</button>
                        </div>
                    </div>
                </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading" (click)="loadHospitalsList(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button>
                    <button *ngIf="myrole=='1' || myrole=='4' || myrole=='6' || myrole=='9'" type="button" class="btn btn-success ml-2" [disabled]="loading" (click)="exportHospitalList()"><i class="fa fa-file-excel"></i> Export List</button>
                </div>
                <div class="col-sm-6"><mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator></div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
            <table class="table table-striped hospitalTable">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Logo</th>
                        <th class="tablefixcoloumn">Name</th>
                        <th>Contact Number</th>
                        <th>Circle</th>
                        <th>City</th>
                        <th *ngIf="myrole=='1' || myrole=='4' || myrole=='9' || myrole=='8' || myrole=='10'">Hospital Registration Certificate</th>
                        <th *ngIf="myrole=='1' || myrole=='4' || myrole=='8' || myrole=='10'">Bio Medical Waste Certificate</th>
                        <th *ngIf="myrole=='1' || myrole=='4' || myrole=='8' || myrole=='10'">NABH</th>
                        <th *ngIf="myrole=='1' || myrole=='4' || myrole=='8' || myrole=='10'">MTP Certificate (For Gynae branch)</th>
                        <th *ngIf="myrole=='1' || myrole=='4' || myrole=='8' || myrole=='9' || myrole=='10'">tge hospital agreement</th>
                        <th *ngIf="myrole=='1' || myrole=='5'  || myrole=='4' || myrole=='8' || myrole=='9' || myrole=='10'">Packages</th>
                        <th *ngIf="myrole=='1' || myrole=='4' || myrole=='6' || myrole=='8' || myrole=='10'">Hospital Images</th>
                        <th>Status</th>
                        <th  *ngIf="myrole=='1'|| myrole=='6'">Display On Landing Page</th>
                        <th *ngIf="myrole=='1' || myrole=='10'">Active/In-Active</th>
                        <th *ngIf="myrole=='1' || myrole=='9' || myrole=='10' || myrole=='4' || myrole=='6'">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let hospital of hospitalsList;let index = index;">
                        <td >{{(pageIndex*perpage)+index+1}}</td>
                        <td>
                            <img class="img-fluid" *ngIf="hospital.hospital_logo;" alt="hospital_logo" src="{{sc3Url}}{{hospital.hospital_logo}}">
                        </td>
                        <td class="tablefixcoloumn">{{hospital.name}}</td>
                        <td>{{hospital.mobile}}</td>
                       	<td>{{hospital.circle_name}}</td>
                        <td>{{hospital.cityName}}</td>
                        <td *ngIf="myrole=='1' || myrole=='4' || myrole=='9' || myrole=='8' || myrole=='10'">
                            <div *ngIf="hospital.uploadedfiles[1].length > 0; else noRegistartion">
                                <span *ngFor="let registration of hospital.uploadedfiles[1]"><a href="{{sc3Url+registration.filepath}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #noRegistartion>
                                Not uploaded
                            </ng-template>
                        </td>
                        <td *ngIf="myrole=='1' || myrole=='4' || myrole=='8' || myrole=='10'">
                            <div *ngIf="hospital.uploadedfiles[2].length > 0; else noBioWaste">
                                <span *ngFor="let bioWaste of hospital.uploadedfiles[2]"><a href="{{sc3Url+bioWaste.filepath}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #noBioWaste>
                                Not uploaded
                            </ng-template>
                        </td>
                        <td *ngIf="myrole=='1' || myrole=='4' || myrole=='8' || myrole=='10'">
                            <div *ngIf="hospital.uploadedfiles[3].length > 0; else noNABH">
                                <span *ngFor="let nabh of hospital.uploadedfiles[3]"><a href="{{sc3Url+nabh.filepath}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #noNABH>
                                Not uploaded
                            </ng-template>
                        </td>
                        <td *ngIf="myrole=='1' || myrole=='4' || myrole=='8' || myrole=='10'">
                            <div *ngIf="hospital.uploadedfiles[4].length > 0; else noMTP">
                                <span *ngFor="let mtp of hospital.uploadedfiles[4]"><a href="{{sc3Url+mtp.filepath}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #noMTP>
                                Not uploaded
                            </ng-template>
                        </td>
                        <td *ngIf="myrole=='1' || myrole=='4' || myrole=='9' || myrole=='8' || myrole=='10'">
                            <div *ngIf="hospital.uploadedfiles[5].length > 0; else notge">
                                <span *ngFor="let tge of hospital.uploadedfiles[5]"><a href="{{sc3Url+tge.filepath}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #notge>
                                Not uploaded
                            </ng-template>
                        </td>
                        <td *ngIf="myrole=='1'  || myrole=='5' || myrole=='4' || myrole=='9' || myrole=='8' || myrole=='10'">
                            <div *ngIf="hospital.uploadedfiles[6].length > 0; else noPackage">
                                <span *ngFor="let package of hospital.uploadedfiles[6]"><a href="{{sc3Url+package.filepath}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #noPackage>
                                Not uploaded
                            </ng-template>
                        </td>

                        <td *ngIf="myrole=='1' || myrole=='4' || myrole=='6' || myrole=='8' || myrole=='10'">
                            <div *ngIf="hospital.uploadedfiles[7].length > 0; else noHospitalImage">
                                <span *ngFor="let hospitalImage of hospital.uploadedfiles[7]"><a href="{{sc3Url+hospitalImage.filepath}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #noHospitalImage>
                                Not uploaded
                            </ng-template>
                        </td>


                        <td>
                        	<span class="badge bg-green-light" *ngIf="hospital.status=='1'">Active</span>
                        	<span class="badge bg-azure-light" *ngIf="hospital.status=='0'">In-Active</span>
                        </td>
                        <td *ngIf="myrole=='1' || myrole=='6'">
                            <mat-slide-toggle [checked]="hospital.display_on_LP=='1'" (change)="showOnLP($event,hospital.id,index)"></mat-slide-toggle>
                        </td>

                        <td *ngIf="myrole=='1' || myrole=='10'">
                            <mat-slide-toggle [checked]="hospital.status=='1'" (change)="onStatusChange($event,hospital.id,index)"></mat-slide-toggle>
                        </td>
                        <td *ngIf="myrole=='1' || myrole=='9' || myrole=='10' || myrole=='4' || myrole=='6'">
                             <div class="dropdown">
                                <button class="btn btn-secondary dropdown-toggle" type="button" id="{{hospital.id}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Action
                                </button>
                                <div class="dropdown-menu" aria-labelledby="{{hospital.id}}">
                                    <a *ngIf="myrole=='1'  || myrole=='3' || myrole=='4' || myrole=='6' || myrole=='2' || myrole=='5' || myrole=='8' || myrole=='10' || myrole=='9'" class="dropdown-item" routerLink="/update-hospital/{{hospital.id}}"><i class="fa fa-pen"></i> Update</a>
                                    <a *ngIf="myrole=='1'  || myrole=='3' || myrole=='4'  || myrole=='9'" class="dropdown-item" routerLink="/hospital-opd/{{hospital.id}}"><i class="fa fa-eye"></i> View OPD</a>
                                    <a *ngIf="myrole=='1'  || myrole=='3' || myrole=='4'  || myrole=='9'"  class="dropdown-item" routerLink="/hospital-ipd/{{hospital.id}}"><i class="fa fa-eye"></i> View IPD</a>
                                </div>
                             </div>
                        </td>
                    </tr>
                    <tr *ngIf="loading">
                        <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                    </tr>
                    <tr *ngIf="loaded && !hospitalsList.length">
                        <td colspan="20" ><i class="far fa-frown"></i> Hospitals not found</td>
                    </tr>
                </tbody>
            </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
    </div>
</div>


<!--  Modal For Update Hospital Ranking Field -->
<div class="modal fade" id="myModalLeadStatusUpdate">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Import Data </h4>
          <button type="button" class="close" (click)="hideRankingStatusUpdateModal()"></button>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                      <label class="col-sm-12">Upload CSV</label>
                      <input [disabled]="submitted" type="file" #csvHospitalRankingFieldUpdate (change)="rankingUpdate($event)" class="form-control" />
                  </div>
                  <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
              </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideRankingStatusUpdateModal()">Close</button>
        </div>
      </div>
    </div>
</div>

<!-----Modal For Update Hospital Data From Csv----->
<div class="modal fade" id="updateDataModal" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Import Hospital Data </h4>
                <button type="button" class="close" (click)="hideModal()"></button>
            </div>
            <!-- Modal body -->
            <div class="modal-body">
                <div class="form-group">
                    <div class="row">
                        <label class="col-sm-12">Upload CSV</label>
                        <input [disabled]="submitted" type="file" #csvUpload (change)="selectFile($event)"
                            class="form-control" />
                    </div>
                    <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
                </div>
                <div class="form-group" [innerHTML]="uploaded_msg | safe:'html'">

                </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn" (click)="hideModal()">Close</button>
            </div>
        </div>
    </div>
</div>
